"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPSERT = exports.REPLACE = exports.DELETE = exports.UPDATE = exports.INSERT = exports.POPULATE = void 0;
var POPULATE = 'schema.populate';
exports.POPULATE = POPULATE;
var INSERT = 'schema.insert';
exports.INSERT = INSERT;
var UPDATE = 'schema.update';
exports.UPDATE = UPDATE;
var DELETE = 'schema.delete';
exports.DELETE = DELETE;
var REPLACE = 'schema.replace';
exports.REPLACE = REPLACE;
var UPSERT = 'schema.upsert';
exports.UPSERT = UPSERT;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sharingapples/redux/dist/schema/types.js
// module id = 594
// module chunks = 2